export const getParentPath = (rootPath: string) => {
  let targetRoot = rootPath;
  if (rootPath !== '/') {
    const path = rootPath.split('/');
    path.pop();
    targetRoot = path.join('/') || '/';
  }
  return targetRoot;
};
